// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__5YNJN","grid":"Skills_grid__Pa3gk","cell":"Skills_cell__IvS5W","waves":"Skills_waves__FPaTf","top":"Skills_top__IniSV","bottom":"Skills_bottom__5cV-h"};